import React, { useState, useEffect, useMemo } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const Step = ({ number, label, active, onClick }) => {
  return (
    <FlexContainer
      className={'flex-column align-items-center pointer'}
      style={{ minWidth: 80 }}
      onClick={onClick}
    >
      <FlexContainer
        className={'width-26px height-26px align-items-center justify-center text-12 index-2'}
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className={'text-10 margt4 text-center width-240px'}
        style={{ color: '#53595f', fontWeight: '700' }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const DetalleReasignarMedicoCitaModal = ({ open, onClose, doctors }) => {
  const [activeTab, setActiveTab] = useState('medicos');
  const [filteredDoctorList, setFilteredDoctorList] = useState([]);

  useEffect(() => {
    if (doctors) {
      setFilteredDoctorList(doctors);
    }
  }, [doctors]);

  const listaEspecialidades = useMemo(() => {
    if (!doctors) return [];
    return Array.from(
      new Set(
        doctors
          .map((medico) => medico.especialidad)
          .filter((especialidad) => especialidad)
          .map((especialidad) => especialidad.trim().toUpperCase()),
      ),
    );
  }, [doctors]);

  const changueEspFilter = (esp) => {
    console.log('aqui');
    const specialidadAFiltrar = esp ? esp.trim().toUpperCase() : null;
    let newFilteredList = [];
    if (!specialidadAFiltrar || specialidadAFiltrar === 'TODAS') {
      newFilteredList = doctors;
      console.log('aca');
    } else {
      console.log('aca ', esp);
      newFilteredList = doctors.filter((doctor) => {
        const doctorSpecialidad = doctor.especialidad
          ? doctor.especialidad.trim().toUpperCase()
          : '';
        return doctorSpecialidad === specialidadAFiltrar;
      });
    }
    console.log('asdsss ', newFilteredList);
    setFilteredDoctorList(newFilteredList);
  };

  //console.log(doctors);
  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-940px height-600px padtb26 padlr80"
        style={{
          borderRadius: '6px 6px 6px 6px',
          boxShadow: '0px 8px 22px rgba(0,0,0,0.15)',
          background: '#ffffff',
          transform: 'scale(0.9)',
          transformOrigin: 'center',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-center justify-center fontWhite"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div className="width100 height-550px bgWhite borderrad20 padtb16 padlr10 pos-rel margb20">
          <FlexContainer className=" width100 margb8">
            <FlexContainer className="align-items-center pos-rel">
              <FlexContainer
                className="pos-abs left110 right110 top12 height-2px borderrad4 index-1"
                style={{ background: '#6f8ec0' }}
              />
              <FlexContainer className="justify-between width100 index-2">
                <Step number={1} label={'Especialidad'} active={false} />
                <Step number={2} label={'Médico'} active={false} />
                <Step number={3} label={'Fecha y Hora Disponibles'} active={true} />
                <Step number={4} label={'Confirmar Reserva de Cita'} active={false} />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>

          {/* Header */}
          <FlexContainer className="align-center gap-10 padtb0 margb8">
            <FlexContainer
              className="align-center width-24px height-24px justify-center pointer"
              style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
            >
              <span
                className="text-20 lineHeight-1"
                style={{ color: '#6f8ec0', fontWeight: 'bold' }}
              >
                ‹
              </span>
            </FlexContainer>

            <div className="text-18" style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Reagenda una cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}> Elige un médico o fecha</span>
            </div>
          </FlexContainer>

          {/* Filters */}
          <FlexContainer className="flex-row gap-16 margt4 width100">
            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>Miraflores</option>
              </select>
              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
                onChange={(e) => changueEspFilter(e.target.value, true)}
              >
                <option value="TODAS"> Todas las especialidades</option>

                {listaEspecialidades?.map((esp, i) => (
                  <option key={i} value={esp}>
                    {esp}
                  </option>
                ))}
              </select>
              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="flex-row width100 margt16">
            <FlexContainer
              className="flex-1 justify-center pointer padtb6"
              style={{
                borderBottom: activeTab === 'medicos' ? '3px solid #023B7A' : '1px solid #ccc',
              }}
              onClick={() => setActiveTab('medicos')}
            >
              <Label
                className="text-14 fontBold"
                style={{ color: activeTab === 'medicos' ? '#023B7A' : '#888' }}
              >
                Médicos
              </Label>
            </FlexContainer>
            <FlexContainer
              className="flex-1 justify-center pointer padtb6"
              style={{
                borderBottom: activeTab === 'fecha' ? '3px solid #023B7A' : '1px solid #ccc',
              }}
              onClick={() => setActiveTab('fecha')}
            >
              <Label
                className="text-14 fontBold"
                style={{ color: activeTab === 'fecha' ? '#023B7A' : '#888' }}
              >
                Fecha
              </Label>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="my-custom-scroll margt16 width100 height-300px overflowY padr0 pos-rel padb16">
            {activeTab === 'medicos' && (
              <FlexContainer
                className="grid width100"
                style={{
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '20px',
                  padding: '12px 40px',
                }}
              >
                {filteredDoctorList?.map((doc, i) => (
                  <FlexContainer
                    key={i}
                    className="flex-row align-center pointer borderrad16 bgWhite height-100px"
                    style={{
                      padding: '18px 20px',
                      minHeight: 90,
                      border: '1px solid #EAEAEA',
                      boxShadow: '0px 4px 14px rgba(0,0,0,0.10)',
                      transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                      gap: '14px',
                    }}
                  >
                    <FlexContainer
                      className="justify-center align-center padt16"
                      style={{ width: 56, height: 56 }}
                    >
                      <img
                        src={'/doctors/' + doc?.imagen}
                        alt={doc.nombres}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </FlexContainer>

                    <FlexContainer className="flex-column justify-center" style={{ flex: 1 }}>
                      <Label className="text-20" style={{ color: '#023B7A', lineHeight: 1.1 }}>
                        <strong>{doc.nombres}</strong>
                      </Label>
                      <Label className="text-16" style={{ color: '#6B6B6B', marginTop: 4 }}>
                        {doc.especialidad}
                      </Label>
                    </FlexContainer>
                  </FlexContainer>
                ))}
              </FlexContainer>
            )}

            {activeTab === 'fecha' && (
              <FlexContainer className="flex-column align-center justify-center height100">
                <Label className="text-14 fontSemiBold" style={{ color: '#023B7A' }}>
                  Selecciona fecha disponible
                </Label>
                <Label className="text-12 margt4" style={{ color: '#666' }}>
                  (Aquí irán las fechas — solo UI por ahora)
                </Label>
              </FlexContainer>
            )}
          </FlexContainer>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default DetalleReasignarMedicoCitaModal;
